var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessibility-statement",domProps:{"innerHTML":_vm._s(_vm.$t('AccessibilityStatement'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }